// Note: types exposed from `index.d.ts`.
export {grammars as all} from './lib/all.js'
export {grammars as common} from './lib/common.js'
export {createLowlight} from './lib/index.js'
